export default function Footer({
  isBackAllowed = false,
  isNextAllowed = false,
  isSaveAsDraft = false,
  hideBackButton = false,
  disableSaveAsDraft = false,
  nextButtonText = "Continue",
  backButtonAction = () => {},
  nextButtonAction = () => {},
  saveAsDraftAction = () => {},
  className = ""
}) {
  
  return (
    <>
      <footer className={"footer "+className}>
        {!hideBackButton && <button
          className="btn backbtn"
          onClick={() => backButtonAction()}
          disabled={!isBackAllowed}
        >
          Back
        </button>}
        <div>
          {isSaveAsDraft && (
            <button disabled={disableSaveAsDraft} onClick={() => saveAsDraftAction()} className="btn text-btn">Save as Draft</button>
          )}

          <button
            className={`btn backbtn btn-primary ${
              !isNextAllowed ? "btn-disabled" : ""
            }`}
            onClick={() => nextButtonAction()}
            disabled={!isNextAllowed}
          >
            {typeof(nextButtonText) === "string" ? nextButtonText : nextButtonText()}
          </button>
        </div>
      </footer>
    </>
  );
}
